/**
 * Conversión de HTML a texto plano.
 *
 * Las descripciones de las propiedades se guardan como HTML (se editan con
 * react-quill y se renderizan con dangerouslySetInnerHTML), pero para pegar en
 * Instagram o WhatsApp hace falta texto plano con los saltos de línea
 * preservados.
 */

/**
 * Convierte un string HTML en texto plano.
 *
 * El orden importa: primero se sacan los tags y recién después se decodifican
 * las entidades. Al revés, un `&lt;script&gt;` guardado en la descripción se
 * convertiría en un tag real justo antes del strip. El resultado sólo se usa
 * como value de un TextField y para el portapapeles, nunca como innerHTML.
 *
 * @param {?string} html
 * @returns {string}
 */
export function htmlToPlainText(html) {
  if (!html || typeof html !== 'string') return '';

  const withBreaks = html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li|h[1-6]|tr)>/gi, '\n')
    .replace(/<li[^>]*>/gi, '• ');

  const withoutTags = withBreaks.replace(/<[^>]*>/g, '');

  const textarea = document.createElement('textarea');
  textarea.innerHTML = withoutTags;
  const decoded = textarea.value;

  return decoded
    .replace(/\u00a0/g, ' ')
    .split('\n')
    .map(line => line.replace(/[ \t]+/g, ' ').trim())
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

/**
 * Recorta un texto en el límite de palabra más cercano y le agrega puntos
 * suspensivos. Devuelve el texto original si ya entra en el máximo.
 *
 * @param {?string} text
 * @param {number} max
 * @returns {string}
 */
export function truncateText(text, max) {
  if (!text || typeof text !== 'string') return '';
  if (!max || text.length <= max) return text;

  const cut = text.slice(0, max);
  const lastSpace = cut.lastIndexOf(' ');
  const base = lastSpace > max * 0.6 ? cut.slice(0, lastSpace) : cut;

  return base.replace(/[\s.,;:]+$/, '') + '…';
}

export default { htmlToPlainText, truncateText };
